module.exports = __webpack_public_path__ + "img/stock0.28ecf0c2.png";